// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2af94f2","239":"39368dd8","453":"793e8aa4","455":"54202ac9"}[chunkId] + ".chunk.js";
};